// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabChildrenFrame--SOMXW {
  /*top: 47px;*/
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/NavbarDropdownFrame/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB","sourcesContent":[".tabChildrenFrame {\n  /*top: 47px;*/\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabChildrenFrame": `tabChildrenFrame--SOMXW`
};
export default ___CSS_LOADER_EXPORT___;
